<div class="flex items-center justify-start">
  <mat-icon color="{{ data.color }}">{{ data.icon }}</mat-icon>
  <span class="ml-2">{{ data.message }}</span>
</div>
